import type { ChromeCopy } from './types'

export const pa: ChromeCopy = {
  appName: 'ਸਮਝੋ',
  tagline: 'ਕਾਗ਼ਜ਼ ਸਮਝੋ। ਅਗਲਾ ਕਦਮ ਜਾਣੋ।',
  savedTitle: 'ਸੇਵ ਕੀਤੇ ਕਾਗ਼ਜ਼',
  upcomingTitle: 'ਆਉਣ ਵਾਲੀਆਂ ਆਖ਼ਰੀ ਤਾਰੀਖ਼ਾਂ',
  markDone: 'ਕੰਮ ਹੋ ਗਿਆ',
  doneLabel: 'ਹੋ ਗਿਆ',
  deadlineCheckIn: '{n} ਸੇਵ ਕੀਤੇ ਕਾਗ਼ਜ਼ ਦੀ ਆਖ਼ਰੀ ਤਾਰੀਖ਼ ਨੇੜੇ ਹੈ। ਕੰਮ ਹੋ ਗਿਆ?',
  savedHint: 'ਇਹ ਸਿਰਫ਼ ਇਸੇ ਫ਼ੋਨ ਵਿੱਚ ਹਨ। ਕਾਗ਼ਜ਼ ਦੀ ਫ਼ੋਟੋ ਅਤੇ ਉਸ ਵਿੱਚ ਲਿਖਿਆ ਸਾਰਾ ਕੁਝ ਕਦੇ ਸੇਵ ਨਹੀਂ ਹੁੰਦਾ, ਸਿਰਫ਼ ਜ਼ਰੂਰੀ ਜਾਣਕਾਰੀ।',
  emptySaved: 'ਅਜੇ ਕੋਈ ਕਾਗ਼ਜ਼ ਸੇਵ ਨਹੀਂ ਕੀਤਾ ਗਿਆ।',
  clearAll: 'ਸਾਰੇ ਮਿਟਾਓ',
  deleteItem: 'ਮਿਟਾਓ',
  aboutTitle: 'ਨਿੱਜਤਾ ਅਤੇ ਜ਼ਰੂਰੀ ਜਾਣਕਾਰੀ',
  privacyPoints: [
    'ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਦੀ ਫ਼ੋਟੋ ਅਤੇ ਉਸ ਵਿੱਚ ਲਿਖੀਆਂ ਗੱਲਾਂ ਇਸੇ ਫ਼ੋਨ ਉੱਤੇ ਪੜ੍ਹੀਆਂ ਅਤੇ ਸਮਝਾਈਆਂ ਜਾਂਦੀਆਂ ਹਨ। ਫ਼ੋਟੋ ਕਿਤੇ ਵੀ ਅੱਪਲੋਡ ਨਹੀਂ ਹੁੰਦੀ।',
    'ਜਦੋਂ ਤੱਕ ਤੁਸੀਂ "ਸੇਵ ਕਰੋ" ਨਹੀਂ ਦੱਬਦੇ, ਕੁਝ ਵੀ ਸੇਵ ਨਹੀਂ ਹੁੰਦਾ। "ਨਵਾਂ ਕਾਗ਼ਜ਼" ਦੱਬਦੇ ਹੀ ਪਿਛਲਾ ਕਾਗ਼ਜ਼ ਸਕਰੀਨ ਅਤੇ ਮੈਮਰੀ ਤੋਂ ਹਟ ਜਾਂਦਾ ਹੈ।',
    'ਸੇਵ ਕਰਨ ਉੱਤੇ ਸਿਰਫ਼ ਜ਼ਰੂਰੀ ਜਾਣਕਾਰੀ (ਤਾਰੀਖ਼ਾਂ, ਰਕਮ, ਨੰਬਰ) ਰੱਖੀ ਜਾਂਦੀ ਹੈ, ਉਹ ਵੀ ਸਿਰਫ਼ ਇਸੇ ਫ਼ੋਨ ਵਿੱਚ — ਫ਼ੋਟੋ ਜਾਂ ਪੂਰਾ ਲਿਖਿਆ ਹੋਇਆ ਨਹੀਂ। ਤੁਸੀਂ ਇਸਨੂੰ ਕਦੇ ਵੀ ਮਿਟਾ ਸਕਦੇ ਹੋ।',
    'ਇੰਟਰਨੈੱਟ ਸਿਰਫ਼ ਤਿੰਨ ਕੰਮਾਂ ਲਈ ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ: ਪਹਿਲੀ ਵਾਰ ਪੜ੍ਹਨ ਵਾਲਾ ਟੂਲ ਅਤੇ ਆਵਾਜ਼ਾਂ (ਸਮਝੋ ਦੀ ਆਪਣੀ ਸਾਈਟ ਤੋਂ) ਡਾਊਨਲੋਡ ਕਰਨ ਲਈ, ਅਤੇ — ਸਿਰਫ਼ ਜੇ ਤੁਸੀਂ ਕਹੋ — ਕਾਗ਼ਜ਼ ਦੀਆਂ ਅੰਗਰੇਜ਼ੀ ਲਾਈਨਾਂ ਦਾ ਅਨੁਵਾਦ ਕਰਨ ਲਈ। ਅਨੁਵਾਦ ਲਈ ਭੇਜੀਆਂ ਲਾਈਨਾਂ ਸਾਂਭੀਆਂ ਨਹੀਂ ਜਾਂਦੀਆਂ, ਅਤੇ ਆਧਾਰ ਅਤੇ ਫ਼ੋਨ ਵਰਗੇ ਨੰਬਰ ਪਹਿਲਾਂ ਹੀ ਹਟਾ ਦਿੱਤੇ ਜਾਂਦੇ ਹਨ। ਤੀਜਾ — ਸਿਰਫ਼ ਜੇ ਤੁਸੀਂ ਸਵਾਲ ਪੁੱਛੋ: ਜਵਾਬ ਲਿਖਣ ਲਈ ਕਾਗ਼ਜ਼ ਦੀ ਲਿਖਤ ਅਤੇ ਤੁਹਾਡਾ ਸਵਾਲ ਸਮਝੋ ਦੇ ਸਰਵਰ ਅਤੇ ਇੱਕ AI ਸੇਵਾ (Groq) ਉੱਤੇ ਜਾਂਦੇ ਹਨ, ਆਧਾਰ, ਪੈਨ, ਫ਼ੋਨ ਅਤੇ ਈਮੇਲ ਪਹਿਲਾਂ ਹਟਾ ਕੇ; ਸਿਰਫ਼ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਵੇਖੀਆਂ ਜਾਂਦੀਆਂ ਹਨ, ਅਤੇ ਕੁਝ ਵੀ ਸਾਂਭਿਆ ਨਹੀਂ ਜਾਂਦਾ। ਜੋ ਲਾਈਨਾਂ ਅੰਗਰੇਜ਼ੀ ਵਿੱਚ ਨਹੀਂ ਹਨ, ਉਨ੍ਹਾਂ ਦਾ ਅਨੁਵਾਦ ਇੱਕ AI ਸੇਵਾ (Groq) ਕਰਦੀ ਹੈ।',
    'ਸਮਝੋ ਵਿੱਚ ਕੋਈ ਇਸ਼ਤਿਹਾਰ ਨਹੀਂ ਹੈ। ਅਸੀਂ ਸਿਰਫ਼ ਇਹ ਗਿਣਦੇ ਹਾਂ ਕਿ ਕਿੰਨੇ ਲੋਕ ਐਪ ਖੋਲ੍ਹਦੇ ਹਨ (Cloudflare Web Analytics, ਬਿਨਾਂ ਕੂਕੀ ਦੇ)। ਇਸ ਵਿੱਚ ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਦੀ ਕੋਈ ਗੱਲ ਸ਼ਾਮਲ ਨਹੀਂ ਹੁੰਦੀ, ਅਤੇ ਕਾਗ਼ਜ਼ ਵਿੱਚ ਲਿਖੀਆਂ ਗੱਲਾਂ ਕਦੇ ਵੀ ਲੌਗ (ਦਰਜ) ਨਹੀਂ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ।'
  ],
  disclaimerTitle: 'ਇਹ ਸਰਕਾਰੀ ਜਾਂ ਕਾਨੂੰਨੀ ਸਲਾਹ ਨਹੀਂ ਹੈ',
  disclaimer: 'ਸਮਝੋ ਇੱਕ ਆਜ਼ਾਦ ਮਦਦ ਵਾਲਾ ਟੂਲ ਹੈ, ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟ ਨਹੀਂ। ਇਹ ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਨੂੰ ਸੌਖੀ ਭਾਸ਼ਾ ਵਿੱਚ ਦੱਸਦਾ ਹੈ, ਪਰ ਇਸਦੀ ਸਮਝ ਅਧਿਕਾਰਤ ਜਾਂ ਕਾਨੂੰਨੀ ਨਹੀਂ ਹੈ। ਜ਼ਰੂਰੀ ਗੱਲਾਂ ਹਮੇਸ਼ਾ ਅਸਲ ਕਾਗ਼ਜ਼ ਜਾਂ ਜਾਰੀ ਕਰਨ ਵਾਲੇ ਦਫ਼ਤਰ ਨਾਲ ਮਿਲਾ ਲਓ।',
  contactTitle: 'ਕੋਈ ਦਿੱਕਤ ਹੈ?',
  contact: 'ਜੇ ਕੋਈ ਦਿੱਕਤ ਹੋਵੇ, ਤਾਂ ਸਾਡੇ ਨਾਲ ਇਸ ਈਮੇਲ ਉੱਤੇ ਸੰਪਰਕ ਕਰੋ:',
  freeTitle: 'ਬਿਲਕੁਲ ਮੁਫ਼ਤ',
  free: 'ਸਮਝੋ ਓਪਨ-ਸੋਰਸ ਟੂਲਾਂ ਨਾਲ ਚੱਲਦਾ ਹੈ: ਪੜ੍ਹਨ ਲਈ Tesseract, ਅਤੇ ਬੋਲਣ ਲਈ ਤੁਹਾਡੇ ਫ਼ੋਨ ਦੀ ਆਪਣੀ ਆਵਾਜ਼ ਜਾਂ Meta ਦੀਆਂ ਓਪਨ MMS ਆਵਾਜ਼ਾਂ (CC BY-NC 4.0)। ਕੋਈ ਖਾਤਾ ਨਹੀਂ, ਕੋਈ ਪੈਸਾ ਨਹੀਂ।',
  shareApp: 'WhatsApp ਉੱਤੇ ਸ਼ੇਅਰ ਕਰੋ',
  installApp: 'ਐਪ ਫ਼ੋਨ ਵਿੱਚ ਜੋੜੋ',
  offline: 'ਤੁਸੀਂ ਆਫ਼ਲਾਈਨ ਹੋ',
  offlineHint: 'ਜੇ ਸਮਝੋ ਪਹਿਲਾਂ ਵਰਤਿਆ ਗਿਆ ਹੈ, ਤਾਂ ਕਾਗ਼ਜ਼ ਬਿਨਾਂ ਇੰਟਰਨੈੱਟ ਦੇ ਵੀ ਪੜ੍ਹਿਆ ਜਾ ਸਕਦਾ ਹੈ।',
  shareAppMessage: 'ਸਰਕਾਰੀ ਕਾਗ਼ਜ਼ ਸੌਖੀ ਭਾਸ਼ਾ ਵਿੱਚ ਸਮਝਣ ਅਤੇ ਸੁਣਨ ਲਈ SAMJHO ਵਰਤੋ (ਮੁਫ਼ਤ):\nhttps://samjho.pages.dev'
}
